import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMusic, faUsers, faComments } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../../../contexts/LanguageContext';

const EventTabs = ({ activeTab, onTabChange, event }) => {
  const { t } = useLanguage();
  const handleTabClick = (tab, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    onTabChange(tab);
  };

  // Check if this is a party event
  const isPartyEvent = event && event.event_type === 'party';

  // For party events, render attendees and comments tabs (no setlist)
  if (isPartyEvent) {
    return (
      <div className="event-tabs">
        <button
          className={`event-tab ${activeTab === 'attendees' ? 'active' : ''}`}
          onClick={(e) => handleTabClick('attendees', e)}
        >
          <FontAwesomeIcon icon={faUsers} className="event-tab-icon" />
          {t('events.attendees.title')}
        </button>
        <button
          className={`event-tab ${activeTab === 'comments' ? 'active' : ''}`}
          onClick={(e) => handleTabClick('comments', e)}
        >
          <FontAwesomeIcon icon={faComments} className="event-tab-icon" />
          {t('events.comments.title')}
        </button>
      </div>
    );
  }

  // For all other event types, render setlist, attendees, and comments tabs
  return (
    <div className="event-tabs">
      <button
        className={`event-tab ${activeTab === 'setlist' ? 'active' : ''}`}
        onClick={(e) => handleTabClick('setlist', e)}
      >
        <FontAwesomeIcon icon={faMusic} className="event-tab-icon" />
        {t('events.setlist.title')}
      </button>
      <button
        className={`event-tab ${activeTab === 'attendees' ? 'active' : ''}`}
        onClick={(e) => handleTabClick('attendees', e)}
      >
        <FontAwesomeIcon icon={faUsers} className="event-tab-icon" />
        {t('events.attendees.title')}
      </button>
      <button
        className={`event-tab ${activeTab === 'comments' ? 'active' : ''}`}
        onClick={(e) => handleTabClick('comments', e)}
      >
        <FontAwesomeIcon icon={faComments} className="event-tab-icon" />
        {t('events.comments.title')}
      </button>
    </div>
  );
};

export default EventTabs;